module.exports = __webpack_public_path__ + "img/gift-07-c1.06cefcbe.png";